export enum ControleEstoqueLoteSituacaoFiltroEnum {
  SemFiltro = 0,
  Reservado = 1,
  Disponivel = 2,
}
